export default "__VITE_ASSET__Bmi6tbCN__"